module.exports = __webpack_public_path__ + "img/back.bb1fdb68.png";